<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <div class="header-cont">
        <Header v-if="!spanish" title="The Artist" />
        <Header v-if="spanish" title="El Artista" />
      </div>
    </b-container>

    <PlayerSpotlight
      playerName="PABLO SERRANO"
      :playerImages="[
        require('@/assets/images/galleries/pablo/theartist/Pablo-Serrano-01.jpg'),
        require('@/assets/images/galleries/pablo/theartist/Pablo-Serrano-02.jpg')
      ]"
      :orientation="'vertical'"
    >
      <div slot="primaryParagraph">
        <p v-if="!spanish">
          Pablo Serrano is a lifelong Chicago artist and cultural worker focused
          on creating public art and social musical experiences. He is most known
          for his murals in Pilsen that focus on continuing the Mexican Muralist
          legacy in service to the immigrant communities of Chicago. He combines 
          muralism, art, education and collaborations with diverse creative partners
          to create culture with and for the community.
          <br><br>
          His most recent projects are the monumental “Somos Pilsen” mural painted
          in collaboration with photographer Mateo Zapata. He is currently
          working on murals for downtown Elgin and and Pasteur Elementary School.
          When not painting, he organizes diverse musical events as a part of Kombi
          Chicago and The People’s Stage Karaoke.
          <br><br>
          To learn more about Pablo Serrano or to view his work visit:
          <a
            href="https://pabloserranoart.com/"
            target="_blank"
            style="color: #ce0e2d"
            >www.pabloserranoart.com.</a
          >
        </p>
        <p v-if="spanish">
          Pablo Serrano es un artista y trabajador cultural de Chicago de toda la vida,
          centrado en la creación de arte público y experiencias musicales sociales. Es
          conocido sobre todo por sus murales en Pilsen que se centran en continuar el
          legado de los muralistas mexicanos al servicio de las comunidades de inmigrantes
          de Chicago. Combina el muralismo, la educación artística y la colaboración con
          diversos socios creativos para crear cultura con y para la comunidad. 
          <br><br>
          Sus proyectos más recientes son el monumental mural ""Somos Pilsen"", pintado en
          colaboración con el fotógrafo Mateo Zapata. Actualmente está trabajando en murales
          para el centro de Elgin y la escuela primaria Pasteur. Cuando no está pintando,
          organiza diversos eventos musicales como parte de Kombi Chicago y The People's Stage Karaoke. 
          <br><br>
          Para conocer más sobre Pablo Serrano o ver su obra visita:
          <a
            href="https://pabloserranoart.com/"
            target="_blank"
            style="color: #ce0e2d"
            >www.pabloserranoart.com.</a
          >
        </p>
      </div>
    </PlayerSpotlight>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import PlayerSpotlight from "@/components/global/PlayerSpotlight";

export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
    PlayerSpotlight,
  },
  props: ["spanish"]
};
</script>

<style lang="scss" scoped>
#the-artist {
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .header-cont {
    margin-top: 90px;
    margin-bottom: 40px;
  }
  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
}
</style>
